import script from "./UpdateAppraisalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateAppraisalPage.vue?vue&type=script&setup=true&lang=js"

import "./UpdateAppraisalPage.vue?vue&type=style&index=0&id=1a2b9a82&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a2b9a82"]])

export default __exports__